/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Actions_Done_EmptyInputs */



/**
* | output |
* | --- |
* | "Nothing is completed yet." |
*
* @param {Meeting_Prep_Actions_Done_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_actions_done_empty = /** @type {((inputs?: Meeting_Prep_Actions_Done_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Actions_Done_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Hier staat nog niets afgerond.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rien n'est encore terminé.")
	return /** @type {LocalizedString} */ ("Nothing is completed yet.")
});